import Vue from 'vue'
import Router from 'vue-router'

import Logout from '@/views/Logout'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import(/* webpackChunkName: "Dashboard" */ '@/views/Login'),
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout,
    },
    
    {
      path: '/',
      name: 'Dashboard',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "Dashboard" */ '@/views/Dashboard'),
    },

    {
      path: '/cars',
      name: 'Cars',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "Cars" */ '@/views/cars/Cars'),
    },
    {
      path: '/cars/preload',
      name: 'PreloadCars',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "Cars" */ '@/views/cars/ImportPreloadCars'),
    },
    {
      path: '/cars/batch-load/:action',
      name: 'BatchLoading',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "CarView" */ '@/views/cars/BatchLoading'),
    },
    {
      path: '/cars/print-labels',
      name: 'PrintLabels',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "CarView" */ '@/views/cars/PrintLabels'),
    },
    {
      path: '/cars/:id',
      name: 'CarView',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "CarView" */ '@/views/cars/CarView'),
    },
    {
      path: '/cars/:id/charges',
      name: 'CarCharges',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "CarCharges" */ '@/views/cars/CarCharges'),
    },
    {
      path: '/damages',
      name: 'Damages',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "Cars" */ '@/views/damages/Damages'),
    },
    {
      path: '/map',
      name: 'Map',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "Map" */ '@/views/map/Map'),
    },
    
    {
      path: '/clients',
      name: 'Clients',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "Clients" */ '@/views/clients/Clients'),
    },
    {
      path: '/clients/:id',
      name: 'ClientsDetail',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "Clients" */ '@/views/clients/ClientDetail'),
    },
    {
      path: '/clients/:id/edit',
      name: 'ClientsForm',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "Clients" */ '@/views/clients/ClientForm'),
    },
    {
      path: '/clients/:id/fares',
      name: 'ClientFaresForm',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "Clients" */ '@/views/clients/ClientFares'),
    },
    
    {
      path: '/users',
      name: 'Users',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "Users" */ '@/views/users/Users'),
    },
    {
      path: '/employees',
      name: 'Employees',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "Users" */ '@/views/employees/Employees'),
    },
    
    {
      path: '/brands',
      name: 'Brands',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "Brands" */ '@/views/brands/Brands'),
    },
    
    
    {
      path: '/controls',
      name: 'Controls',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "Controls" */ '@/views/controls/Controls'),
    },
    {
      path: '/control/:carId',
      name: 'CarDetail',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "CarAdmission" */ '@/views/controls/CarDetail'),
    },
    
    {
      path: '/settings',
      name: 'Settings',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "CarAdmission" */ '@/views/settings/Settings'),
    },

    {
      path: '/transfers',
      name: 'Transfers',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "Clients" */ '@/views/transfers/Transfers'),
    },


    // {
    //   path: '/control/:carId/admission',
    //   name: 'CarAdmission',
    //   meta: { 
    //     requiresAuth: true
    //   },
    //   component: () => import(/* webpackChunkName: "CarAdmission" */ '@/views/controls/CarAdmission'),
    // },
    
    // {
    //   path: '/control/:carId/dispatch',
    //   name: 'CarDispatch',
    //   meta: { 
    //     requiresAuth: true
    //   },
    //   component: () => import(/* webpackChunkName: "CarDispatch" */ '@/views/controls/CarDispatch'),
    // },
    // {
    //   path: '/control/:carId/pre-delivery',
    //   name: 'CarPreDelivery',
    //   meta: { 
    //     requiresAuth: true
    //   },
    //   component: () => import(/* webpackChunkName: "CarAdmission" */ '@/views/controls/CarPreDelivery'),
    // },
    // {
    //   path: '/control/:carId/delivery',
    //   name: 'CarDelivery',
    //   meta: { 
    //     requiresAuth: true
    //   },
    //   component: () => import(/* webpackChunkName: "CarAdmission" */ '@/views/controls/CarDelivery'),
    // },
    // {
    //   path: '/control/:carId/charges',
    //   name: 'CarCharges',
    //   meta: { 
    //     requiresAuth: true
    //   },
    //   component: () => import(/* webpackChunkName: "CarCharges" */ '@/views/controls/CarCharges'),
    // },
    // {
    //   path: '/control/:carId/transfer-:action',
    //   name: 'CarTransfer',
    //   meta: { 
    //     requiresAuth: true
    //   },
    //   component: () => import(/* webpackChunkName: "CarTransfer" */ '@/views/controls/CarTransfer'),
    // },
    
    {
      path: '*',
      redirect: '/'
    }
  ]
})

router.beforeEach((to, from, next) => {
  var loggedIn = localStorage.getItem('logged-admin');
  loggedIn = JSON.parse(loggedIn)
  // console.log('router.beforeEach loggedIn', loggedIn);
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (loggedIn && loggedIn['is_admin'] ) {
      //console.log('router  estoy logueado')
      next()
      return
    }
    //console.log('router  go to login')
    next('/login') 
    // next()
  } else {
    next()
  }
})

export default router